<template>
 <v-row class="pl-2 pr-2">
  <v-col col="12" v-if="text" >
    <div v-for="(error,index) in text" :key="index" >
    <v-alert @input="onClose"  dismissible class="red"   type="error" :value="true" >
      {{ error }}
    </v-alert>  
    </div>
  </v-col> 
 </v-row>
</template>

<script>
  export default {
    name: "Alert",
    props:['text'],
    data () {
      return {
        alert: true
      }
    },
    methods: {
        onClose(){
          this.$emit('dismissed');
        }
    }
  }
</script>